export const environment = {
  production: false,
  origin: 'https://dev.pygmalios.com',
  storyblok_api_key: '5B7CQoSNDcbzmySiQ7hosgtt',
  storyblok_api_version: 'draft',
  recaptcha_site_key: '6LeaCEseAAAAAOzyYk5Q7bhyCLQ4P99Vjw2Zs3dL',
};
